import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { GeoJSONObject } from '@/types/geospatial'
import { Infestation, LayerValue } from '@/types/weed-diagnosis'

export interface GetInfestationFromDemandResponse {
  id: string
  infestations: Infestation[]
  total_infestation_area: LayerValue
  total_area: LayerValue
  thumbnail: string
  perimeter: GeoJSONObject
  demand_name: string
  mosaic: {
    date: string
    datum: string
    gsd: number
  }
  status: {
    name: string
    label: string
    description: string
    status_key: 'registered' | 'processing' | 'completed' | 'rejected'
  }
  concluded_at: string
}

export async function getInfestationFromDiagnosis(
  culture: string,
  demandId: string,
  options?: AxiosRequestConfig,
) {
  const { data } = await companiesApi.get<GetInfestationFromDemandResponse>(
    apiRoutes.getSummaryInfestation(culture, demandId),
    options,
  )

  return data
}
